// extracted by mini-css-extract-plugin
var _1 = "eHQc7GDt3PPPEDcOXG4_";
export { _1 as "root" }
